import React from 'react'
import styled from 'styled-components'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import { ink, radius, surface, font, transition } from 'features/dashboard/tokens'

const BackLink = ({ onClick, children, className, title }) => (
  <Link type='button' onClick={onClick} className={className} title={title}>
    <ArrowBackRoundedIcon style={{ fontSize: 16 }} />
    <span>{children}</span>
  </Link>
)

export default BackLink

const Link = styled.button`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 34px;
  padding: 0 12px 0 10px;
  border: none;
  border-radius: ${radius.pill};
  background: transparent;
  color: ${ink.mute};
  font-family: inherit;
  font-size: ${font.small};
  font-weight: 600;
  cursor: pointer;
  transition: ${transition};

  &:hover {
    background: ${surface.wash};
    color: ${ink.base};
  }

  &:focus-visible {
    outline: 2px solid #33becc;
    outline-offset: 2px;
  }
`
